import { Glue42 } from "../../glue";
import callbackRegistry, { CallbackRegistry } from "callback-registry";

export class Glue42Notification implements Glue42.Notifications.Glue42Notification {
    public readonly actions: Glue42.Notifications.Glue42NotificationAction[];
    public id: string;
    public instanceId: string;
    public panelExpiry: number;
    public toastExpiry: number;
    public badge: string;
    public body: string;
    public data: any;
    public dir: NotificationDirection;
    public icon: string;
    public image: string;
    public lang: string;
    public renotify: boolean;
    public requireInteraction: boolean;
    public silent: boolean;
    public tag: string;
    public timestamp: number;
    public title: string;
    public readonly vibrate: number[];

    [k: string]: any;

    public onclick: ((ev: Event) => any);
    public onclose: ((ev: Event) => any);
    public onerror: ((ev: Event) => any);
    public onshow: ((ev: Event) => any);
    public onaction: ((ev: Glue42.Notifications.ActionEvent) => any) | null;

    private callbacks: CallbackRegistry = callbackRegistry();

    public constructor(public options: Glue42.Notifications.Glue42NotificationOptions) {
        this.actions = options.actions;
        this.body = options.body;
        this.badge = options.badge;
        this.data = options.data;
        this.dir = options.dir;
        this.icon = options.icon;
        this.image = options.image;
        this.lang = options.lang;
        this.renotify = options.renotify;
        this.requireInteraction = options.requireInteraction;
        this.silent = options.silent;
        this.tag = options.tag;
        this.timestamp = options.timestamp;
        this.title = options.title;
    }

    public close(): void {
        throw new Error("Method not implemented.");
    }
    public addEventListener<K extends "click" | "close" | "error" | "show">(type: K, listener: (this: Notification, ev: NotificationEventMap[K]) => any, options?: boolean | AddEventListenerOptions): void;
    public addEventListener(type: string, listener: EventListenerOrEventListenerObject, options?: boolean | AddEventListenerOptions): void;
    public addEventListener(type: any, listener: any, options?: any) {
        this.callbacks.add(type, listener);
    }
    public removeEventListener<K extends "click" | "close" | "error" | "show">(type: K, listener: (this: Notification, ev: NotificationEventMap[K]) => any, options?: boolean | EventListenerOptions): void;
    public removeEventListener(type: string, listener: EventListenerOrEventListenerObject, options?: boolean | EventListenerOptions): void;
    public removeEventListener(type: any, listener: any, options?: any) {
        // DO NOTHING FOR NOW
    }
    public dispatchEvent(event: Event): boolean {
        this.callbacks.execute(event.type, event);
        return true;
    }
}
